/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { REDIRECT_TO_CLEAR } from './redirect-clear';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpCacheService {
  private requests: any = {};

  insert(urlWithoutId: string, response: HttpResponse<any>): void | undefined {
    this.requests[urlWithoutId] = response;
  }

  get(urlWithoutId: string): HttpResponse<any> | undefined {
    return this.requests[urlWithoutId];
  }

  delete(url: string): void {
    const urlWithoutId = url.match(/(.+)\/\d+$/);
    if (urlWithoutId?.length > 0) {
      url = urlWithoutId[1];
    }
    delete this.requests[url];
    this.redirectToClear(url);
  }

  redirectToClear(url: string) {
    const baseUrl = url.split(environment.baseUrl);
    const path = baseUrl[1];
    const pathsToClear = REDIRECT_TO_CLEAR.find(
      (item) => item.origin === path
    )?.pathToClear;
    if (pathsToClear) {
      const urls = pathsToClear.map((pathToClear) =>
        url.replace(path, pathToClear)
      );
      urls.forEach((url) => delete this.requests[url]);
    }
  }

  getKeys() {
    return Object.keys(this.requests);
  }
}
